import { Lci3SalesMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { theme } from '@features/executive-report/domain/theme';
import { TextProps } from '@features/powerpoint';
import { formatters } from '@utils/formattersV2';

type CampaignTextsOptions = {
  period: 'end' | 'middle';
  xOffset: number;
  salesMetrics: Lci3SalesMetrics | null;
};

const campaignPeriodText = (
  options: Pick<CampaignTextsOptions, 'period' | 'xOffset'>
): TextProps => ({
  text: [
    {
      text: options.period.toUpperCase(),
      options: {
        bold: true,
      },
    },
    {
      text: ' of campaign'.toUpperCase(),
    },
  ],
  options: {
    fontSize: 14,
    color: theme.colors.white,
    h: 0.34,
    w: 2.59,
    x: 0.66 + options.xOffset,
    y: 2.06,
  },
});

export const campaignTexts = (options: CampaignTextsOptions): TextProps[] => {
  if (!options.salesMetrics) return [];

  return [
    campaignPeriodText(options),
    {
      text: 'Lift'.toUpperCase(),
      options: {
        fontSize: 10,
        color: theme.colors.white,
        h: 0.27,
        w: 0.5,
        x: 0.82 + options.xOffset,
        y: 2.86,
      },
    },
    {
      text: formatters.currency(options.salesMetrics.incrementalSales.total, {
        full: true,
        decimals: 0,
      }),
      options: {
        fontSize: 20,
        color: theme.colors.inmarketGreen,
        bold: true,
        align: 'center',
        h: 0.44,
        w: 2.17,
        x: 1.52 + options.xOffset,
        y: 2.77,
      },
    },
    {
      text: formatters.lift(options.salesMetrics.incrementalSalesLift.total, {
        decimals: 1,
      }),
      options: {
        fontSize: 20,
        color: theme.colors.inmarketGreen,
        align: 'center',
        h: 0.44,
        w: 1.24,
        x: 3.51 + options.xOffset,
        y: 2.77,
      },
    },
    {
      text: 'Total Incrementality'.toUpperCase(),
      options: {
        fontSize: 8,
        color: theme.colors.white,
        bold: true,
        h: 0.37,
        w: 1.33,
        x: 4.64 + options.xOffset,
        y: 2.81,
      },
    },
  ];
};
